import { DATE_ERROR, SEARCH_NO_FLIGHTS_AVAILABLE } from '@/constants/Srp'
import { ErrorIcon } from '@/assets/icons/ErrorIcon'
import { Button, Container, Typography } from '@cleartrip/ct-design-components'

const ERROR_BLOCK_STYLE = { paddingTop: 52, paddingBottom: 52 }

type SearchErrorType = {
    errorType: string
}
const SearchError = ({ errorType }: SearchErrorType) => {
    let title = ''
    let subTitle = ''
    let buttonText = 'Home'

    let onButtonClick = () => {
        window.location.href = '/'
    }
    switch (errorType) {
        case SEARCH_NO_FLIGHTS_AVAILABLE:
            title = 'No flights found for this search'
            subTitle = 'Please try again, with different airports or dates'
            break
        case DATE_ERROR:
            title = 'Looks like your dates are in the the past'
            break
        default:
            title = 'Sorry our servers are stumped with your request. Please check your url.'
            subTitle = "Looks like you've entered a wrong url, please check the url or try searching again"
    }
    return (
        <Container className="flex flex-middle flex-center px-8" css={ERROR_BLOCK_STYLE}>
            <Container className="flex flex-column flex-middle flex-center" width="512px">
                <ErrorIcon />
                <Typography variant="HM1" className="mt-7 ta-center">
                    {title}
                </Typography>
                <Typography variant="P1" color="subheading" className="mt-4 ta-center">
                    {subTitle}
                </Typography>
                <Button variant="contained" color="tertiary" className="w-50p mt-8" onClick={onButtonClick}>
                    <Typography variant="P1" color="neutral" className="c-pointer">
                        {buttonText}
                    </Typography>
                </Button>
            </Container>
        </Container>
    )
}

export default SearchError
